<template>
	<page>
		<module>
			<view-list work-type="19" ref="view" :view-config="auth('b_stock_summary_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="仓库">
							<c-select name="warehouse_ids" async multiple @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="批次号" v-show="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="库存收发时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
					</m-search>
				</template>
				<template #operate>
					<c-button v-if="auth('b_stock_summary_export')" v-lock="lock('b_stock_summary_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_summary_export')" v-lock="lock('b_stock_summary_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				<!--库存数量-->
				<template #product_count="{data}">
					<strong v-if="data.product_count && data.product_count > 0" style="color: green">{{data.product_count}}</strong>
					<strong v-else-if="data.product_count && data.product_count < 0" style="color: red">{{data.product_count}}</strong>
					<span v-else>{{data.product_count}}</span>
				</template>
				<!--库存状态-->
				<template #stock_state="{data}">
					<c-state dict="stockStateName" :value="data.stock_state"></c-state>
				</template>
				<!--期初数量-->
				<template #start_storage_count="{data}">
					<strong v-if="data.start_storage_count && data.start_storage_count > 0" style="color: green">{{data.start_storage_count}}</strong>
					<strong v-else-if="data.start_storage_count && data.start_storage_count < 0" style="color: red">{{data.start_storage_count}}</strong>
					<span v-else>{{data.start_storage_count}}</span>
				</template>
				<!--期末数量-->
				<template #end_storage_count="{data}">
					<strong v-if="data.end_storage_count && data.end_storage_count > 0" style="color: green">{{data.end_storage_count}}</strong>
					<strong v-else-if="data.end_storage_count && data.end_storage_count < 0" style="color: red">{{data.end_storage_count}}</strong>
					<span v-else>{{data.end_storage_count}}</span>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		computed: {
		  // 获取dictName选项数据
		  ...mapState(['systemConfig']),
		},
		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					start_date: new Date(now.getTime() - (30 * 24 * 60 * 60 * 1000)).format('yyyy-MM-dd 00:00:00'),
					end_date: new Date().format('yyyy-MM-dd 23:59:59')
				}
			}
		},
		methods: {
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>